import type { TefComsCancelButton } from '@mfe/components/TefComsCancelButton';
import { componentStateStore } from '@mfe/store';
import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

// a simple button that triggers an event and disables itself
export const tefComsButton = function render(this: TefComsCancelButton) : ReturnType<typeof html> {
  const classes = {
    button: true, 'button-default--prio-secondary': true, 'button-tag--state-disabled': componentStateStore.disabled,
  };

  return html`
    <button class=${classMap(classes)} @click="${this.handleClick}" ?disabled=${componentStateStore.disabled}>
       ${this.text}
    </button>
  `;
};
